<template>
    <div class="border border-tc-gray-4 rounded-md overflow-hidden cursor-pointer bg-white" @click="clickCampaign()">
        <!-- <div class="campaign-image" :style="{'background-image': `url('${campaign.fullImageUrl}')`}"></div> -->
        <div class="w-full h-32">
            <img class="h-full w-full mx-auto" :src="campaign.fullImageUrl" />
        </div>
        <div class="px-4 py-2">
            <div class="text-20 text-tc-gray-3 text-2-line h-12">{{campaign.name}}</div>
        </div>
        <div class="px-2">
            <div class="border-t border-tc-gray-4 py-2 flex items-center">
                <div class="text-tc-gray-3 text-22 mr-5px">{{ campaign.pointType == 'get' ?  lbl.campaign.get :  lbl.campaign.use }}</div>
                <div class="text-tc-blue-1 text-25 font-bold">
                    <span class="campaign-baht" v-if="isShowBaht">
                        ฿{{ FilterNumberFormat(campaign.maximumPartialPrice) }} + {{FilterNumberFormat(campaign.maximumPartialPoints ?? 0)}}
                    </span>
                    <span class="campaign-baht" v-if="!isShowBaht"> 
                        {{FilterNumberFormat(campaign.pointPerUnit ?? 0)}}
                    </span>
                </div> 
                <img class="point-icon" src="../../../../assets/icon/tipCoin.svg" alt="tipCoin"> 
            </div>
        </div>
    </div>
</template>
<script>
import LocaleMixin from "@/mixin/LocaleMixin.js";
import { CampaignType } from "@/helper/StaticValue.js";

export default {
    name: "CampaignItem",
    mixins: [LocaleMixin],
    props: {
        campaign: { type: Object, required: true },
    },
    computed: {
        isShowBaht: function () {
            return (this.campaign.type ==   CampaignType.Privilege20);
        },
    },
    methods: {
        getPointMessage: function () {
            var pointType = this.campaign.pointType == 'get' ? this.lbl.campaign.get_point : this.lbl.campaign.use_point;
            var pointUnit = this.lbl.campaign.point + (this.campaign.pointPerUnit > 1 && this.localeCode == 1033 ? 's' : '');
            return pointType + " " + this.campaign.pointPerUnit + " " + pointUnit;
        },

        clickCampaign: function() {
            this.$router.push('/campaign/' + this.campaign.id);
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/image.scss";
    .campaign-image {
        @include boxRatio($ratio: 66.66%);
    }
    .point-icon {
        width: 12px;
        margin-left: 5px;
    }
</style>
